export enum SickLeaveState {
	UNPROCESSED = 'UNPROCESSED',
	FILE_MISSING = 'FILE_MISSING',
	MEDDI_FAIL = 'MEDDI_FAIL',
	CSSZ_FAIL = 'CSSZ_FAIL',
	CSSZ_PROCESSING = 'CSSZ_PROCESSING',
	CSSZ_REJECTED = 'CSSZ_REJECTED',
	CSSZ_ACCEPTED = 'CSSZ_ACCEPTED',
}
